<template>
  <div class="bg-grey-lines block-fullscreen">
    <div class="header-logo">
      <icon name="td-logo" color="#393f49" />
    </div>
    <section class="block-fullscreen-center block-fullscreen-text">
      <div class="title-float">
        <span>I</span>
        <span>N</span>
        <span>T</span>
        <span>R</span>
        <span>O</span>
      </div>
      <div class="title-main">
        <p>A Transformação Digital já atingiu todos os setores do mercado mas, apesar disso, são poucos os que realmente entendem o que ela significa para os negócios e qual a sua relevância para a sobrevivência empresarial.</p>
        <p>Dada sua enorme magnitude, é difícil entender o panorama digital como um todo, então vamos começar o teste de maturidade digital a partir das definições básicas.</p>
      </div>
      <router-link to="/intro/formulario" class="nav-arrow-down">
        <div class="title hidden-sm">
          Avançar
        </div>
        <icon name="arrow-line-right" class="arrow-right animation-blink" />
      </router-link>
    </section>
  </div>
</template>

<script>
import Icon from './Icon';
import rollDown from './mixins/rollDown';

/* eslint-disable max-len */
export default {
  name: 'intro',
  mixins: [rollDown],
  components: { Icon },
  data() {
    return {
      nextScreen: '/intro/formulario',
    };
  },
  mounted() {
    this.$store.commit('SET_BAR_PROGRESS', 1);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Intro.vue